(function() {
    var link = document.createElement('link');
    //link.rel = "stylesheet";
    link.rel = "prefetch";
    link.setAttribute("as", "font");
    link.href = "https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700&display=swap";
    document.querySelector("head").appendChild(link);
})();


